import { Grid } from "@mui/material";
import { Control, Controller, useFormContext } from "react-hook-form";
import { TextFieldInput } from "../../../../Forms/TextFieldInput";
import { BidPackSelect } from "../../../BidPacks/Form/BidPackSelect";
import { defaultRateAgreementBidPack, RateAgreementBidPack } from "../../RateAgreementBidPack";
import { RateAgreement } from "../../RateAgreement";
import { MdmFormProps } from "../../../../Forms/MdmFormProps";
import { isElementInArray } from "../../../../Utils/arrays";
import { nameOf } from "../../../../Utils/nameOf";

type Props = {
  bidPackIndex: number;
  control: Control<RateAgreement>;
  rateAgreementId: number | null;
};

export const RateAgreementBidPackSubForm = ({
  bidPackIndex,
  control,
  rateAgreementId,
  disabledFields,
}: Props & MdmFormProps) => {
  const {
    setValue,
    formState: { disabled: isFormDisabled, errors },
  } = useFormContext<RateAgreement>();

  const updateDestinationName = (
    bidPackId: number,
    rateAgreementBidPacks: RateAgreementBidPack[]
  ) => {
    const selectedBidPack = rateAgreementBidPacks?.find(
      (rateAgreementBidPack) => rateAgreementBidPack.Id === bidPackId
    );

    setValue(`AssignedBidPacks.${bidPackIndex}`, selectedBidPack ?? defaultRateAgreementBidPack);
  };

  return (
    <Grid container item columnSpacing={4}>
      <Grid item xs={4}>
        <Controller
          name={`AssignedBidPacks.${bidPackIndex}.Id`}
          control={control}
          render={({ field }) => (
            <BidPackSelect
              field={field}
              error={!!errors?.AssignedBidPacks}
              errorMessage={errors.AssignedBidPacks?.message}
              rateAgreementId={rateAgreementId}
              onBidPackChanged={updateDestinationName}
              disabled={
                isFormDisabled ||
                isElementInArray(disabledFields, nameOf<RateAgreement>("AssignedBidPacks"))
              }
            />
          )}
        />
      </Grid>
      <Grid item xs={4}>
        <TextFieldInput
          control={control}
          label="Destination Name"
          name={`AssignedBidPacks.${bidPackIndex}.DestinationName`}
          disabledFields={disabledFields}
        />
      </Grid>
    </Grid>
  );
};
